export default __webpack_public_path__ + "static/media/Stranglers Arm-straps of Charred Earth.14821a14.jpg";